<mat-drawer-container class="sidenav-container">
  <mat-drawer
    #drawer
    mode="side"
    [opened]="loginService.drawerOpened.value && this.showSidenav"
    class="sidenav"
    [class.collapsed]="!isExpanded"
  >
    @if (isExpanded) {
    <button class="menu-item" mat-flat-button (click)="toggleSidenav()">
      <mat-icon>chevron_left</mat-icon>Fechar Menu
    </button>
    } @else {
    <div class="menu-item-center">
      <button mat-icon-button (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    }

    <div class="sidenav-header">
      <img
        [src]="
          isExpanded
            ? 'https://assets.broadfactor.com/login-broadfactor/assets/png/broadfactorLogo.png'
            : 'https://assets.broadfactor.com/login-broadfactor/assets/png/logo.png'
        "
        class="logo"
      />
    </div>

    @for(item of menus; track item){ @if(isExpanded){
    <button [routerLink]="item.route" class="menu-item" mat-flat-button>
      <mat-icon [class.active]="activeRoute.includes(item.route)">{{
        item.icon
      }}</mat-icon
      ><span [class.active]="activeRoute.includes(item.route)">{{
        item.title
      }}</span>
    </button>
    } @else {
    <div class="menu-item-center">
      <button [routerLink]="item.route" mat-icon-button>
        <mat-icon [class.active]="activeRoute.includes(item.route)">{{
          item.icon
        }}</mat-icon>
      </button>
    </div>
    } }

    <div class="user-info">
      @if(showHelp){ @if(isExpanded){
      <button class="menu-item" mat-flat-button (click)="openDialog()">
        <mat-icon class="comofunciona">help</mat-icon
        ><span class="comofunciona">Como Funciona</span>
      </button>
      } @else {
      <div class="menu-item-center" (click)="openDialog()">
        <button mat-icon-button>
          <mat-icon class="comofunciona">help</mat-icon>
        </button>
      </div>
      } } @if(isExpanded){
      <button class="menu-item" mat-flat-button [matTooltip]="userName">
        <mat-icon>person</mat-icon>{{ userName | truncate : 10 }}
      </button>
      } @else {
      <div class="menu-item-center">
        <button
          mat-icon-button
          (click)="isExpanded = true"
          [matTooltip]="userName"
        >
          <mat-icon>person</mat-icon>
        </button>
      </div>
      } @if(isExpanded){
      <button class="menu-item" mat-flat-button (click)="loginService.logout()">
        <mat-icon class="logout">logout</mat-icon
        ><span class="logout">Sair</span>
      </button>
      } @else {
      <div class="menu-item-center" (click)="loginService.logout()">
        <button mat-icon-button>
          <mat-icon class="logout">logout</mat-icon>
        </button>
      </div>
      }
    </div>
  </mat-drawer>

  <mat-drawer-content
    autosize
    [ngStyle]="{ 'margin-left': isExpanded ? '250px' : '70px' }"
  >
    <ng-content></ng-content
  ></mat-drawer-content>
</mat-drawer-container>
